<h3>Employer Details</h3>

<nz-descriptions [nzColumn]="{ xxl: 6, xl: 4, lg: 4, md: 3, sm: 2, xs: 1 }" nzLayout="vertical" nzBordered class="mt-2">
	<nz-descriptions-item *ngFor="let property of getDynamicProperties(employer.properties)" [nzTitle]="property">{{employer.properties[property]}}</nz-descriptions-item>
</nz-descriptions>
